import { useState } from "react";
import { Pagination } from "../interfaces/RequestBase";

export const InfinityPagination: Pagination = {
	page: 0,
	size: 1000000,
} 

export const DefaultPagination: Pagination = {
	page: 0,
	size: 25,
}

const usePagination = () => {
	const [pagination, setPagination] = useState<Pagination>({
		page: 0,
		size: 10,
	});

	const setPage = (page: number) => {
		var timePagintaion = { ...pagination };
		timePagintaion.page = page;
		setPagination(timePagintaion);
	};

	const setPageSize = (size: number) => {
		var timePagintaion = { ...pagination };
		timePagintaion.size = size;
		setPagination(timePagintaion);
	};

	return [pagination as Pagination, setPage, setPageSize];
};

export default usePagination;
